/**
 * Shared "is this content item active/visible" check for tab badge counts
 * (coordinator, course hub, and student pages). One place to define what
 * "active" means instead of raw array.length or ad-hoc enabled checks.
 */

function sessionStatusFor(session, todayIso) {
  if (!session?.sessionDate) return "upcoming";
  if (session.sessionDate > todayIso) return "upcoming";
  if (session.sessionDate === todayIso) return "today";
  return "completed";
}

/**
 * isContentActive(item, { sessionsById, todayIso })
 * - item.enabled defaults to true (only an explicit `false` excludes it)
 * - if item.sessionId references a known session that hasn't date-unlocked
 *   yet (status must be "today" or "completed"), the item is inactive
 * - class-level items (no sessionId) with enabled !== false are always active
 * - a sessionId with no matching entry in sessionsById can't be checked, so
 *   it's left active rather than hidden
 */
export function isContentActive(item, { sessionsById = {}, todayIso } = {}) {
  if (!item) return false;
  if (item.enabled === false) return false;

  if (item.sessionId != null) {
    const session =
      sessionsById[item.sessionId] ?? sessionsById[String(item.sessionId)];
    if (session) {
      const today = todayIso || new Date().toISOString().slice(0, 10);
      const status = sessionStatusFor(session, today);
      if (status !== "today" && status !== "completed") return false;
    }
  }

  return true;
}

export function countActive(list, opts) {
  return (Array.isArray(list) ? list : []).filter((item) =>
    isContentActive(item, opts),
  ).length;
}
